import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MilestoneCelebrationModalComponent} from '../milestone-celebration-modal/milestone-celebration-modal.component';
import {properties} from '../../../../environments/properties'
import {Title} from '@angular/platform-browser';
import {SubscriptionService} from "../../../shared/services/subscription.service";
import {ParamService} from "../../../shared/services/param.service";
import {AuthService} from "../../../shared/services/auth.service";
import {CouponGridService} from "../../../shared/services/coupon-grid.service";
import {ModalService} from "../../../shared/services/modal.service";
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {findNestedObj, _windowUtil} from '../../../shared/utils/ui-utils';
import { ICouponModel, J4uV1Service, UserInfoService } from 'abs-ngx-library/src/lib/core';
import { of, Subject } from 'rxjs';
import { switchMap, catchError, takeUntil, finalize } from 'rxjs/operators';


declare let $: any;

@Component({
    selector: 'app-confirmation-summary',
    templateUrl: './confirmation-summary.component.html',
    styleUrls: ['./confirmation-summary.component.scss'],
    providers: [SubscriptionService]
})
export class ConfirmationSummaryComponent implements OnInit , OnDestroy{

    userSubscriptionDetails: any;
    userSubscriptionProfile: any;
    authUserInfo: any;
    tenderInfo: any;
    userInfo: any;
    storeId: string;
    errorMessage: string;
    isB2B: boolean;
    freshpassBenefitsJSON: any;
    coupons: any = [];
    hasCoupons: boolean = false;
    isTrialPlan: boolean;
    freshpassSubscriptionType: string;
    subscriptionStatus: string;
    status: string;
    lifeSavings: number;
    showVipSummary: boolean = false;
    displayCreditPreview: boolean = false;

    bannerColors = {
        blue: '#00529F',
        red: '#DD1E25',
        black: '#2c2a29',
        green: '#437f2f'
    }
    bannerColor: string = this.bannerColors.red;

    userFirstName: string = '';
    userLastName: string = '';
    currentEnvironment;
    partnersData: any;
    enablePartners: boolean = properties.featureFlags.enablePartners;
    enablePartnersOffersV2: boolean = false;
   
    PARTNER_OFFER_TITLE: string = properties.partnersOffers.PARTNER_OFFER_TITLE;
    PARTNER_OFFER_SUBTITLE: string = properties.partnersOffers.PARTNER_OFFER_SUBTITLE;

    showPartnersComponent = false;

    partnersConfigObj = {
      appName: properties.manage.FRESHPASS,
      programType: properties.confirmation.PARTNERS
    }
    
    public ltoCoupons: any = [];
    public logoProps: any = {};
    public carouselData: any;
    public freshPassCoupons: any;
    public isLtoEnabled: boolean = false;
    
    public isLtoCouponDataLoaded: boolean = false;
    public configObj = {
        appName: properties.manage.FRESHPASS,
        programType: properties.freshpassOffers.freshpassLTO,
      };
    private $destroyed = new Subject<boolean>();
    public windowUtil = _windowUtil(window);
    properties = properties;
    displaySubTypeLink: boolean = true;
    isActive: boolean = false;
    isSuspendedUser: boolean = false;
    banner;

    constructor(public subscriptionService: SubscriptionService,
                private paramService: ParamService,
                private activeRoute: ActivatedRoute,
                public authService: AuthService,
                public couponGridService: CouponGridService,
                private modalService: ModalService,
                private bsModalService: BsModalService,
                private bsModalRef: BsModalRef,
                private titleService: Title,
                private router: Router,
                private j4uV1Service: J4uV1Service,
                private userInfoService: UserInfoService) {
        this.setTitle(this.properties.confirmation.FRESHPASS_SUBSCRIPTION_CONFIRMATION);
        this.banner = this.paramService.banner;
        const partnerPromotionBannerConfig = properties.featureFlags.partnerPromotionBannerConfig;
        this.enablePartnersOffersV2 = properties.featureFlags.enablePartnersOffersV2  && partnerPromotionBannerConfig[this.banner] === true;
        this.isB2B = this.authService.checkB2B();

        this.PARTNER_OFFER_TITLE = this.enablePartnersOffersV2 ? properties.partnersOffers.PARTNER_OFFER_TITLE_V2:properties.partnersOffers.PARTNER_OFFER_TITLE;
        this.PARTNER_OFFER_SUBTITLE = this.enablePartnersOffersV2 ? properties.partnersOffers.PARTNER_OFFER_SUBTITLE_V2:properties.partnersOffers.PARTNER_OFFER_SUBTITLE;
    }

    ngOnInit(): void {
        this.setProps();
        this.initModals();
        this.userNotifyInit();
        if (this.activeRoute.data) {
            this.activeRoute.data.subscribe(data => {
                    let isSessionValid = this.authService.isTokenValidForSession(data.tokenObject)
                    if (isSessionValid) {
                        const sessionData = {...(data.tokenObject), authToken: data.tokenObject['SWY_SHOP_TOKEN']};
                        if (sessionData) {
                            this.userInfo = sessionData;
                            this.isLtoEnabled = properties.featureFlags.enableLTO
                            if (this.isLtoEnabled) {
                                this.userInfoService.setUserSession(this.userInfo)
                            }
                            this.initSubscribes();
                        }
                    } else {
                        this.authService.redirectToSSO(data.tokenObject);
                    }
                },
                (err => {
                    this.authService.redirectToSSO({});
                }));
        }
        this.setCampaignAndActiveNotification();
    }

    setProps(): void {
      this.currentEnvironment = this.subscriptionService.getEnvironment();
      }
 
    initSubscribes(): void {
        this.authUserInfo = this.userInfo;
        (this.isLtoEnabled) ? this.getFilteredCoupons([properties.freshpassOffers.freshpassPerks, properties.freshpassOffers.freshpassLTO]) : this.getFreshpassCoupons();
        
        if (this.enablePartners && !this.isB2B) {
          this.getPartnersData();
        }

        this.getAndSetSubscriptionDetails();
        this.getAndSetUserProfileInfo()
        this.getFreshPassBenefits();

        if (window['AB'] && window['AB']['DATALAYER']) {
            const impressionsObj = {
                partnerCards: this.enablePartners ? this.properties.confirmation.PRTNRS : this.properties.confirmation.NO_PRTNRS
            };
            window['AB']['DATALAYER'].updateAnalyticsSubscriptionInfo(this.properties.confirmation.CONFIRMATION, undefined, impressionsObj);
        }
    }

    setTitle(newTitle): void {
        this.titleService.setTitle(newTitle);
    }

    setCampaignAndActiveNotification() {
        const discountAndActiveNotification = localStorage.getItem('isDiscountCampaignAndActive');

        if (discountAndActiveNotification && discountAndActiveNotification === 'true') {
          const flashReleaseCodeProperty = this.properties.snackbar.discountAndActive;

          if (flashReleaseCodeProperty) {
            this.modalService.setSnackBar(flashReleaseCodeProperty);
            localStorage.setItem('isDiscountCampaignAndActive', 'false');
          }
        }
    }

    getAndSetSubscriptionDetails(): void {
        this.subscriptionService.getUserSubscriptionDetails(this.authUserInfo, this.currentEnvironment).subscribe((data) => {
          if (data && data.Data) {
            this.userSubscriptionDetails = data.Data;
            if (this.userSubscriptionDetails?.subscriptionStatus === this.properties.manage.CANCELLED) {
              this.windowUtil.setWindowLocationHref('/freshpass/manage/subscribe')
            } else {
              this.getTenderDetails();
              this.subscriptionStatus = this.userSubscriptionDetails.subscriptionStatus;
              this.status = this.userSubscriptionDetails.status;
              if (this.subscriptionStatus === this.properties.manage.ACTIVE) {
                 this.isActive = true;
                 } else {
                this.isActive = false;
                } 
            
              if (this.userSubscriptionDetails.status === this.properties.manage.SUSPENDED) {
                this.isSuspendedUser = true;
                 } else {
                this.isSuspendedUser = false;
                }
            
              this.lifeSavings = this.userSubscriptionDetails.lifeSavings || 0;
              this.isTrialPlan = this.getTrialPlanStatus(this.userSubscriptionDetails);
              this.setSubscriptionTypeText(this.userSubscriptionDetails);
              this.getAndSetManagePlanBannerColor();
              this.getDisplayCreditPreview();
              this.displayMilestoneModal(this.userSubscriptionDetails);
            }
          } else {
            this.errorMessage = this.handleError();
          }
        }, error => {
          this.errorMessage = this.handleError(error);
        })
    }

    getTenderDetails(): void {
        this.subscriptionService.getTenders(this.authUserInfo, this.currentEnvironment).subscribe((tenderData) => {
            if (tenderData && tenderData.paymentMethods && tenderData.paymentMethods.length > 0) {
                this.tenderInfo = tenderData.paymentMethods;
            }
        });
    }

    getAndSetUserProfileInfo(): void {
        this.subscriptionService.getUserProfileInfo(this.authUserInfo, this.currentEnvironment).subscribe((data) => {
            if (data) {
                this.userSubscriptionProfile = data;
                if ((this.userSubscriptionProfile.firstName != null) && (this.userSubscriptionProfile.lastName != null) &&
                    (this.userSubscriptionProfile.firstName.length > 0) && (this.userSubscriptionProfile.lastName.length > 0)) {
                    this.userFirstName = this.userSubscriptionProfile.firstName;
                    this.userLastName = this.userSubscriptionProfile.lastName;
                }
            } else {
                this.userFirstName = this.properties.confirmation.WELCOME;
            }
        })
    }

    getTrialPlanStatus = (data): boolean => {
        if ((data.status.toLowerCase() === this.properties.manage.TRIAL.toLowerCase()) || (data.status.toLowerCase() === this.properties.manage.PROCESSING.toLowerCase() && data.previousStatus && data.previousStatus.toLowerCase() === this.properties.manage.TRIAL.toLowerCase())) {
            return true;
        }
        return false;
    }

    setSubscriptionTypeText = (data): void => {
        if (this.isTrialPlan) {
            this.freshpassSubscriptionType = this.properties.manage.FREE_TRIAL;
        } else if (data.subscriptionType.toLowerCase().indexOf(this.properties.manage.MONTHLY.toLowerCase()) >= 0) {
            this.freshpassSubscriptionType = this.properties.manage.MONTHLY_SUBSCRIBER;
        } else {
            this.freshpassSubscriptionType = this.properties.manage.ANNUAL_SUBSCRIBER;
        }
    }

    getAndSetManagePlanBannerColor = (): void => {
        if (this.banner == this.properties.confirmation.ALBERTSONS || this.banner == this.properties.confirmation.STARMARKET) {
            this.bannerColor = this.bannerColors.blue;
        } else if (this.banner == this.properties.confirmation.PAVILIONS) {
            this.bannerColor = this.bannerColors.black;
        } else if (this.banner == this.properties.confirmation.SHAWS) {
            this.bannerColor = this.bannerColors.green;
        } else {
            this.bannerColor = this.bannerColors.red;
        }
    }

    getFreshPassBenefits = (): void => {
      this.subscriptionService.getFreshPassBenefitsJSONAPI(this.currentEnvironment).then((response) => {
        const tileObj = findNestedObj(response, this.properties.confirmation.FRESHPASSTILEPARSYS); 
        if (tileObj) {
          this.freshpassBenefitsJSON = tileObj;
        }
      }, error => {
          console.error(this.properties.confirmation.ERROR_FETCHING_EXPERIENCE_FRAGMENT+`${error}`);
      });
    }

    getFreshpassCoupons = (): void => {
        $('#fp-loading').show().removeClass(this.properties.confirmation.MASK);
        this.couponGridService.getCoupons(this.authUserInfo).subscribe((res) => {
            if (res) {
                this.coupons = this.couponGridService.filterCoupons(res);
                this.hasCoupons = this.coupons.length > 0;
                $('#fp-loading').hide().addClass(this.properties.confirmation.MASK);
            } else {
                $('#fp-loading').hide().addClass(this.properties.confirmation.MASK);
            }
        }, (err) => {
            $('#fp-loading').hide().addClass(this.properties.confirmation.MASK);
        })
    }

    public getFilteredCoupons(programType: string[]) {
        this.showLoadingIndicator();
        this.couponGridService.getCouponsByProgramType(this.authUserInfo, this.currentEnvironment, programType).pipe(
            takeUntil(this.$destroyed),
            switchMap(coupons => this.processCoupons(coupons)),
            catchError(err => this.handleCouponError(err)),
            finalize(() => this.hideLoadingIndicator())
        ).subscribe(logoData => {
            if (this.ltoCoupons?.length > 0) {
                this.isLtoCouponDataLoaded = true;
            } else {
                this.isLtoCouponDataLoaded = false;
            }
            
            if (logoData) {
                this.logoProps = logoData;
            }
        });
    }

    private processCoupons(coupons: any) {
        const { freshPassCoupons, ltoCoupons } = this.filterCoupons(coupons);
        this.coupons = freshPassCoupons;
        this.hasCoupons = this.coupons.length > 0;
        this.ltoCoupons = ltoCoupons;
        if (this.ltoCoupons.length > 0) {
            this.carouselData = {
                title: properties.freshpassOffers.ltoTitle,
                dealsInfo: this.ltoCoupons
            };
            return this.j4uV1Service.getLogoList();
        }else {
            return of(null);
        }
    }

    public filterCoupons(coupons): { freshPassCoupons: ICouponModel[], ltoCoupons: ICouponModel[] } {
        const freshPassCoupons = this.couponGridService.filterCouponsByProgramType(coupons, properties.freshpassOffers.freshpassPerks) ?? [];
        const ltoCoupons = this.couponGridService.filterCouponsByProgramType(coupons, properties.freshpassOffers.freshpassLTO) ?? [];
        return { freshPassCoupons, ltoCoupons };
    }

    public showLoadingIndicator(): void {
        $('#fp-loading').show().removeClass(this.properties.confirmation.MASK);
    }

    public hideLoadingIndicator(): void {
        $('#fp-loading').hide().addClass(this.properties.confirmation.MASK);
    }

    public handleCouponError(err: any) {
        console.error(this.properties.confirmation.ERROR_FETCHING_LOGO_LIST, err);
        if (this.ltoCoupons?.length > 0) {
            this.isLtoCouponDataLoaded = true;
        } else {
            this.isLtoCouponDataLoaded = false;
        }
        
        return of(null);
    }

    initModals(): void {
      this.bsModalService.onShown.subscribe((e) => {
        this.modalService.setMobileFocusLoop(e.target);
      });
      this.bsModalService.onHidden.subscribe(() => {
          this.modalService.removeMobileFocusLoop();
      })
    }

    getDisplayCreditPreview(): void {
        if (!this.userSubscriptionDetails || (this.userSubscriptionDetails.subscriptionType === this.properties.manage.ANNUAL_PLAN && this.userSubscriptionDetails.status.toLowerCase() === this.properties.manage.ACTIVE.toLowerCase()) ||
            this.userSubscriptionDetails.status === this.properties.manage.PROCESSING || this.userSubscriptionDetails.status === this.properties.manage.SUSPENDED ||
            (this.userSubscriptionDetails.subscriptionStatus === this.properties.manage.PENDING_ACTIVATION && this.userSubscriptionDetails.pendingSubscriptionType === this.properties.manage.MONTHLY_PLAN) ||
            this.userSubscriptionDetails.subscriptionStatus === this.properties.manage.PENDING_CANCELLATION) {
            this.displayCreditPreview = false;
        } else {
            this.displayCreditPreview = true;
        }

        if(this.userSubscriptionDetails?.isPrimaryFreshPassUser === false) {
            this.displayCreditPreview = false;
        }
    }

    displayMilestoneModal(data) {
        const celebrationAmount = data.showCelebrationAmount;
        if (celebrationAmount && celebrationAmount > 0 && data.lifeSavings) {
            this.modalService.openModalWithComponent(MilestoneCelebrationModalComponent, {
                initialState: {
                    celebrationAmount: data.lifeSavings,
                },
                class: this.properties.confirmation.CLASS,
                backdrop: this.properties.confirmation.backdrop,
                ariaLabelledBy: this.properties.confirmation.ariaLabelledBy,
                ariaDescribedby: this.properties.confirmation.ariaDescribedby
            })
        }
    }

    handleError(error: any = null): string{
      let errorCode = error?.error?.errorCode;
      let message = '';
      if (errorCode) {
        switch (errorCode) {
            case properties.errorCode.INVALID_REASON_CODE:
                message = properties.errorMessages.INVALID_REASON_MESSAGE;
                break;
            case properties.errorCode.CANCEL_DURING_BATCH_PROCESSING_CODE:
                message = properties.errorMessages.CANCEL_DURING_BATCH_PROCESSING_MESSAGE;
                break;
            case properties.errorCode.CANCEL_WITHIN_BUFFER_TIME_CODE:
                message = properties.errorMessages.CANCEL_WITHIN_BUFFER_TIME_MESSAGE;
                break;
            case properties.errorCode.SERVER_ERROR_CODE:
                message = properties.errorMessages.SERVER_ERROR_MESSAGE;
                break;
            case properties.errorCode.UNKNOWN_ERROR_CODE:
                message = properties.errorMessages.UNKNNOWN_ERROR_MESSAGE;
                break;
            case properties.errorCode.SUBS_PAYMENT_ERROR_CODE:
                message = properties.errorMessages.SUBS_PAYMENT_ERROR_MESSAGE;
                break;
            case properties.errorCode.CARD_UNACCEPTED_ERROR_CODE:
                message = properties.errorMessages.CARD_UNACCEPTED_ERROR_MESSAGE;
                break;
            case properties.errorCode.DEFAULT_NO_SUBSCRIPTION_ERROR_CODE:
                this.router.navigate([properties.urlPath.SUBSCRIBE_PATH]);
                break;
            case properties.errorCode.INVALID_BANNER_CODE:
                this.router.navigate([properties.urlPath.SUBSCRIBE_PATH]);
                break;
            default:
                message = properties.errorMessages.DEFAULT_ERROR_MESSAGE;
                break;
        }
      } else {
        message = properties.errorMessages.DEFAULT_ERROR_MESSAGE;
      }
      this.errorMessage = message;
      return message;
    }

    redirectToLandingPage(): void {
        this.router.navigate([properties.urlPath.SUBSCRIBE_PATH]);
    }

    userNotifyInit = function () {
        let text = localStorage.getItem(this.properties.confirmation.notifyMessage);

        let messageJson = JSON.parse(text);

        if (messageJson && !messageJson.isDisplayed) {
            if (messageJson.message && messageJson.message.length > 0) {
                this.userNotify(messageJson.message);
            }
            messageJson.isDisplayed = true;
            text = JSON.stringify(messageJson);
            localStorage.setItem(this.properties.confirmation.notifyMessage, text);
        }
    };

    userNotify = function (message, options) {
        let def = {
            timeToShow: 8000
        };

        options = $.extend({}, def, options);
        let $notify = $('.notify-wrapper');
        let $msg = $('.notify-wrapper .message');

        // If already visible hide it and then show the next one.
        if ($notify.is(':visible')) {
            $notify.fadeOut(100);
            // Kill the timeout.
            clearTimeout($notify.data(this.properties.confirmation.timeToShow))
        }

        setTimeout(function () {
            $msg.text(message);
            $msg.attr('aria-live', "polite");
        }, 150);

        $notify.fadeIn("slow");

        let timeOut = setTimeout(function () {
            $notify.fadeOut('slow');
        }, options.timeToShow);

        $notify.data(this.properties.confirmation.timeToShow, timeOut);
    };

    ngOnDestroy(): void {
        this.$destroyed.next(true);
        this.$destroyed.complete();
    }

    getPartnersData() {
      let confirmationPageSource = 'paidmembership';
      this.subscriptionService.fetchPartnersCardData(this.userInfo, this.enablePartnersOffersV2, confirmationPageSource).subscribe({
        next: (offers) => {
          if (offers?.length > 0) {
            this.partnersData = {
              title: this.PARTNER_OFFER_TITLE,
              subTitle: this.PARTNER_OFFER_SUBTITLE,
              partnersInfo: offers,
            };
            this.showPartnersComponent = true;
          }
        },
        error: (error) => {
          console.error(this.properties.confirmation.ERROR_FETCHING_PARTNERS_DATA, error);
        }
      });
    }
}
